import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = () => {
  const currentDate = new Date();
  const hour = currentDate?.getHours();
  const timeOfDay = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite';
  const formattedDate = currentDate?.toLocaleDateString('pt-BR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="bg-gradient-to-r from-primary to-accent rounded-lg p-6 text-primary-foreground mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold mb-2">{timeOfDay}, Admin!</h1>
          <p className="text-primary-foreground/80 mb-1">Bem-vindo de volta ao Finet Manager</p>
          <div className="flex items-center space-x-2 text-sm text-primary-foreground/70">
            <Icon name="Calendar" size={16} />
            <span>{formattedDate}</span>
          </div>
        </div>
        <div className="hidden md:flex items-center space-x-4">
          <div className="text-right">
            <p className="text-sm text-primary-foreground/80">Status do sistema</p>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-success rounded-full animate-gentle-pulse" />
              <span className="text-sm font-medium">Todos os sistemas operacionais</span>
            </div>
          </div>
          <div className="w-16 h-16 bg-primary-foreground/10 rounded-full flex items-center justify-center">
            <Icon name="BarChart3" size={32} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;